import { IDisposalReasonGismtDTO, IDisposalReasonGismtViewDTO } from "../../libs/coreapi-dto/dirs/disposalReasonGismt";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class DisposalReasonGismtDataProvider extends DictionaryDataProvider<IDisposalReasonGismtViewDTO, IDisposalReasonGismtDTO> {

    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<IDisposalReasonGismtViewDTO, IDisposalReasonGismtDTO>> {
        return this._coreApiService.disposalReasonGismtRequest
    }
}